module.exports = __webpack_public_path__ + "VIPV17.png?6f508423e45e421ca2c6a805466e69a3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/colours/horses/VIPV17.png
// module id = 111
// module chunks = 0